const rule = {
	name: 'monthYearFormat',
	method: (value) => /^(0[1-9]|10|11|12)?[/. ]?(20[0-9]{2})$/.test(value), // MM/YYYY format
	errorMessage: () => 'Please enter valid MM/YYYY format.'
};

export default rule;
